import { render } from "./LlamadaCamarero.vue?vue&type=template&id=295d0b6a&scoped=true"
import script from "./LlamadaCamarero.vue?vue&type=script&lang=js"
export * from "./LlamadaCamarero.vue?vue&type=script&lang=js"

import "./LlamadaCamarero.vue?vue&type=style&index=0&id=295d0b6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-295d0b6a"]])

export default __exports__